const Loading = () => {
    return (
        <div style={{minHeight:"50vh", display:"flex"}}>
            <span className="spinner"></span>
        </div>
    );
};
export default Loading;
